module.exports = __webpack_public_path__ + "static/img/z-1.43923d8d.png";